import api from './index';

export type VehicleStatus = 'disponivel' | 'manutencao' | 'em_uso';

export interface Vehicle {
  id: number;
  brand: string;
  year: number;
  license_plate: string;
  description: string;
  department_name: string;
  employee_id?: number | null;
  mileage?: number;
  status: VehicleStatus;
  created_at: string;
  updated_at: string;
  fuel?: string;
}

export interface CreateVehicleData {
  brand: string;
  year: number;
  license_plate: string;
  description: string;
  department_name: string;
  employee_id?: number | null;
  mileage?: number;
  status?: VehicleStatus;
  fuel?: string;
}

export type UpdateVehicleData = Partial<CreateVehicleData>;

export interface VehicleService {
  getAllVehicles: () => Promise<Vehicle[]>;
  getVehicleById: (id: number) => Promise<Vehicle>;
  createVehicle: (data: CreateVehicleData) => Promise<Vehicle>;
  updateVehicle: (id: number, data: UpdateVehicleData) => Promise<Vehicle>;
  deleteVehicle: (id: number) => Promise<void>;
}

class VehicleServiceImpl implements VehicleService {
  private baseUrl = '/vehicles';

  async getAllVehicles(): Promise<Vehicle[]> {
    const response = await api.get<Vehicle[]>(this.baseUrl);
    return response.data;
  }

  async getVehicleById(id: number): Promise<Vehicle> {
    const response = await api.get<Vehicle>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  async createVehicle(data: CreateVehicleData): Promise<Vehicle> {
    const response = await api.post<Vehicle>(this.baseUrl, data);
    return response.data;
  }

  async updateVehicle(id: number, data: UpdateVehicleData): Promise<Vehicle> {
    const response = await api.put<Vehicle>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async deleteVehicle(id: number): Promise<void> {
    await api.delete(`${this.baseUrl}/${id}`);
  }
}

export const vehicleService = new VehicleServiceImpl(); 
